"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSerializedValue = exports.labelFromItem = exports.getDisplayValue = exports.getReadOnlyValue = void 0;
/**
 * Transform various formats into a readable string
 */
function getReadOnlyValue(value, items) {
    if (!value) {
        return '';
    }
    // handle multiselect mode
    if (Array.isArray(value)) {
        return items
            .filter((item) => value.includes(valueFromItem(item)))
            .map((item) => labelFromItem(item))
            .join(', ');
    }
    // show label if available, otherwise show value
    const item = items.find((item) => valueFromItem(item) === value);
    return item ? labelFromItem(item) : String(value);
}
exports.getReadOnlyValue = getReadOnlyValue;
/**
 * Parse config and value to get the value to be viewed by user.
 * Uses label if present, falls back to value
 */
function getDisplayValue(value, items) {
    if (!value) {
        return;
    }
    // handle multiselect mode
    if (Array.isArray(value)) {
        return items.filter((item) => value.includes(valueFromItem(item)));
    }
    // show label if available, otherwise show value
    const item = items.find((item) => valueFromItem(item) === value);
    return item ? labelFromItem(item) : value;
}
exports.getDisplayValue = getDisplayValue;
function valueFromItem(item) {
    if (item && typeof item === 'object')
        return item.value;
    return item;
}
function labelFromItem(item) {
    if (item && typeof item === 'object')
        return item.label;
    if (item === null)
        return '';
    return String(item);
}
exports.labelFromItem = labelFromItem;
/**
 * Get the value to be validated and sent to the consumer
 */
function getSerializedValue(item) {
    // handle null and ''
    if (!item) {
        return item;
    }
    // handle multiselect mode
    if (Array.isArray(item)) {
        return item.map(valueFromItem);
    }
    // handle standard/dropdown mode
    return valueFromItem(item);
}
exports.getSerializedValue = getSerializedValue;
//# sourceMappingURL=utils.js.map